import "@/App.css";
import Home from "@/pages/Home";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App relative">
      <Home />
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
